import { Component, Input, OnInit } from '@angular/core';
import { Course } from 'src/app/core/models/api/course.model';
import { ClassesCourse } from 'src/app/core/models/api/classes-course.model';
import { Edition } from 'src/app/core/models/api/edition.model';
import { AreaResourceService } from 'src/app/core/services/api/area-resource.service';
import { CourseResourceService } from 'src/app/core/services/api/course-resource.service';

@Component({
    selector: 'app-course-summary-card',
    templateUrl: './course-summary-card.component.html',
    styleUrls: ['./course-summary-card.component.scss']
})
export class CourseSummaryCardComponent implements OnInit {

    @Input() edition: Edition;
    @Input() course : ClassesCourse;
    
    courseIconPath        : string;
    courseShortDescription: string;
    courseRequirements    : string;

    areaIconPath  : string;
    areaBadgeClass: string;

    constructor(private areaResourceService: AreaResourceService, private courseResourceService: CourseResourceService) { }

    ngOnInit() { 

        this.getCourseResources();
        this.getAreaResources();

    }

    getCourseResources() {

        this.courseIconPath         = this.courseResourceService.findResource(this.course.courseResources, 'icon-bg', this.edition.editionId);
        this.courseShortDescription = this.courseResourceService.findResource(this.course.courseResources, 'short-description', this.edition.editionId);
        this.courseRequirements     = this.courseResourceService.findResource(this.course.courseResources, 'requirements', this.edition.editionId);
        
    }

    getAreaResources() {

        this.areaBadgeClass = this.areaResourceService.findResource(this.course.courseArea.resources, 'badge-class');
        this.areaIconPath   = this.areaResourceService.findResource(this.course.courseArea.resources, 'icon');
        
    }

}
